import { render } from "./EditProductsPage.vue?vue&type=template&id=0ac8dc5c&scoped=true&ts=true"
import script from "./EditProductsPage.vue?vue&type=script&lang=ts"
export * from "./EditProductsPage.vue?vue&type=script&lang=ts"

import "./EditProductsPage.vue?vue&type=style&index=0&id=0ac8dc5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac8dc5c"]])

export default __exports__